import axios from 'axios';

const SERVER_DOMAIN = process.env.REACT_APP_BACKEND_HOST;

// Create axios instance with credentials enabled for cookie support
const axiosInstance = axios.create({
  baseURL: SERVER_DOMAIN,
  withCredentials: true, // Critical: This allows cookies to be sent with requests
  headers: {
    'Content-Type': 'application/json',
  },
});

export default axiosInstance;

